import React from 'react';
import {Button} from 'reactstrap';
import {axiosApi} from '../../assets/axiosAPI';
import {UserAccountForm} from '../parts/index';
import { API_PATH, LOGOUT } from '../../assets/const';
import { createErrorMessage, removeErrorMessageElement, getSessionInfoGeneral } from '../../assets/common';

const LOGIN_USER = API_PATH + "/resources/loginuser";

export default class UserAccount extends React.Component{
    constructor(){
        super();
        this.state = {
            loginUserAccount : {
                oldPassword:"",
                password: ["",""]
            } 
        }
        this.inputPassword = this.inputPassword.bind(this);
        this.inputConfirmPassword = this.inputConfirmPassword.bind(this);
    }

    componentDidMount(){
        getSessionInfoGeneral();
    }

    //更新ボタン押下時に呼ばれる処理
    putLoginUserAccount = () =>{
        //画面に表示されているエラーメッセージ要素を削除
        removeErrorMessageElement();

        //パスワードが一致しているかチェック
        if(this.state.loginUserAccount.password[0] === this.state.loginUserAccount.password[1]){
            axiosApi
            .put(LOGIN_USER, {
                oldPassword : this.state.loginUserAccount.oldPassword,
                password : this.state.loginUserAccount.password[0]
            })
            .then(() => {
                alert("パスワードの更新が完了しました");
                this.setState({
                    loginUserAccount : {
                        oldPassword:"",
                        password: ["",""]
                    }          
                })
            })
            .catch((error) => {
                if(error.response){
                    //通信時のエラー
                    const _statusCode = error.response.status;
                    if(_statusCode === 400){
                        //BadRequest
                        //画面に表示するエラーメッセージを作成
                        if(error.response.data.errorInfo){
                            createErrorMessage(error.response.data.errorInfo);
                        }
                        alert("入力内容を修正してください。");
                    }else if(_statusCode === 401 || _statusCode === 403){
                        //セッション情報なし
                        alert("セッションが切断されました。ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }else{
                        //入らない処理
                        alert("ログイン画面へ戻ります。");
                        window.location.href = LOGOUT;
                    }
                }else{
                    //レスポンス取得後のエラー or 通信失敗時のエラー
                    alert("予期せぬエラーが発生しました。ログイン画面へ戻ります。");
                    window.location.href = LOGOUT;
                } 
            })
        }else{
            alert("パスワードが一致していません。再入力をお願いします。");
        }
    }

    //パスワード入力欄のonChangeイベント
    //stateの更新をする
    inputOldPassword = (event) => {
        let _loginUserAccount = Object.assign({}, this.state.loginUserAccount);
        _loginUserAccount.oldPassword = event.target.value;        
        this.setState({
            loginUserAccount : _loginUserAccount
        })
    }

    //パスワード入力欄のonChangeイベント
    //stateの更新をする
    inputPassword = (event) => {
        //ネストしたstate変更時のエラー回避のための処理
        let _loginUserPassword 
            = this.state.loginUserAccount.password[0];

        let _ConfirmPassword
            = this.state.loginUserAccount.password[1];

        let _oldPassword
            = this.state.loginUserAccount.oldPassword;
            
        if(_loginUserPassword !== null){
            _loginUserPassword = event.target.value;
        }
        this.setState({
            loginUserAccount : {
                oldPassword:_oldPassword,
                password: [
                    _loginUserPassword,
                    _ConfirmPassword
                ]
            } 
        })
    }

    //確認用パスワード入力欄のonChangeイベント
    //stateの更新をする
    inputConfirmPassword = (event) => {
        let _oldPassword
        = this.state.loginUserAccount.oldPassword;

        this.setState({
            loginUserAccount : {
                oldPassword:_oldPassword,
                password: [
                    this.state.loginUserAccount.password[0],                    
                    event.target.value
                ]
            } 
        })
    }

    render(){
        return(
            <div>
                <h1 className="PageTitle">パスワード編集</h1>
                <div className="main" style={{ textAlign:"center"}}>
                    <div style={{textAlign:"left",paddingLeft:"2em"}}>
                        <div style={{marginTop:"1em",marginBottom:"1em"}}>
                            <span>パスワードはすべて半角で英大文字・英小文字・数字・記号をすべて1文字以上含めて8文字以上で設定してください。</span><br/>
                            <span>使用可能な記号は次のものとなります。</span>
                            <span>+-/@#$%&_;:</span>
                        </div>
                    </div>
                    <UserAccountForm 
                        loginUserAccount={this.state.loginUserAccount}
                        inputOldPassword={this.inputOldPassword}
                        inputPassword={this.inputPassword} 
                        inputConfirmPassword={this.inputConfirmPassword}/>
                    <Button 
                        style={{ position: "relative", left:"20%", marginTop:"2em"}}
                        color='primary'
                        onClick={this.putLoginUserAccount}>更新</Button>
                </div>
            </div>
        )
    }
}